import React from 'react';
import ReactSlider from 'rc-slider';
import classnames from 'classnames';
import Text from '../../Text/Text';
import Fade from '../../Transitions/Fade/Fade';

import 'rc-slider/assets/index.css';
import './Slider.scss';

export interface SliderProps {
    /**
     * Ref Slider
     */
    ref?: any;
    /**
     * Value Slider
     */
    value?: number;
    /**
     * Value Slider
     */
    defaultValue?: number;
    /**
     * Marks Slider
     */
    marks?: any;
    /**
     * Step selected of marks Slider
     */
    step?: number | null;
    /**
     * Show dots in Slider
     * @default false
     */
    dots?: boolean;
    /**
     * Min value
     */
    min?: number;
    /**
     * Max value
     */
    max?: number;
    /**
     * Start Point Slider
     */
    startPoint?: number;
    /**
     * Vertical slider
     * @default false
     */
    vertical?: boolean;
    /**
     * Included value slider
     * @default false
     */
    included?: boolean;
    /**
     * Label attr Slider
     */
    label?: string;
    /**
     * Error message
     */
    error?: string;
    /**
     * Disabled
     * @default false
     */
    disabled?: boolean;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Slider class name styles
     */
    sliderClassName?: string;
    /**
     * Function called on change Slider
     */
    onChange?(value?: any): any;
    /**
     * Function called on before change Slider
     */
    onBeforeChange?(value?: any): any;
    /**
     * Function called on after change Slider
     */
    onAfterChange?(value?: any): any;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

/**
 * This component use rc-slider package
 * Doc: https://github.com/react-component/slider
 * Props: https://github.com/react-component/slider#common-api
 */
const Slider: React.FC<SliderProps> = React.forwardRef(
    (
        {
            label,
            value,
            defaultValue,
            marks = undefined,
            step,
            dots = false,
            min,
            max,
            error,
            startPoint,
            vertical = false,
            included = false,
            disabled = false,
            className,
            sliderClassName,
            onChange = () => {},
            onBeforeChange = () => {},
            onAfterChange = () => {},
            ...otherProps
        },
        ref
    ) => {
        const classNames = classnames(['slider', { disabled, vertical }, className]);
        const SliderClassNames = classnames(['slider__slider', sliderClassName]);
        const schemaProps = {
            ...(included ? { included } : {}),
        };

        return (
            <div className={classNames}>
                {label && (
                    <Text tag="label" typo="label" className="slider__label">
                        {label}
                    </Text>
                )}
                <div className="slider__wrapper">
                    <ReactSlider
                        ref={ref}
                        value={value}
                        defaultValue={defaultValue}
                        marks={marks}
                        step={step}
                        min={min}
                        max={max}
                        dots={dots}
                        startPoint={startPoint}
                        vertical={vertical}
                        disabled={disabled}
                        className={SliderClassNames}
                        onChange={onChange}
                        onBeforeChange={onBeforeChange}
                        onAfterChange={onAfterChange}
                        {...schemaProps}
                        {...otherProps}
                    />
                </div>
                {!!error && (
                    <Fade>
                        <Text tag="span" size="12" color="error" className="slider__error">
                            {error}
                        </Text>
                    </Fade>
                )}
            </div>
        );
    }
);

export default Slider;
